import PropTypes from "prop-types";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

import { withRouter } from "@wevideo/core/router/withRouter";

import CookieScripts from "../components/cookieScripts/CookieScripts";
import Tester from "../components/tester/Tester";
import { hasGtmEnabled, isAuth, isInHub } from "../helpers/AppHelper";
import GeneralTrack from "../services/track/GeneralTrack";
import "./../assets/redesignedCss/index.scss";

class DefaultLayout extends Component {
	canTrack = true;

	constructor(props) {
		super(props);

		this.state = {
			appWasLoaded: false,
			appLoadError: null,
		};

		if (!hasGtmEnabled()) {
			this.canTrack = false;
		}
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.appWasLoaded !== prevState.appWasLoaded) {
			return { appWasLoaded: nextProps.appWasLoaded };
		}
		if (nextProps.appLoadError !== prevState.appLoadError) {
			return { appLoadError: nextProps.appLoadError };
		}

		return null;
	}

	componentDidMount() {
		this.trackDataLayerSession();
		GeneralTrack.getInstance().processSessionStorageEvents();

		this.props.history.listen((location, action) => {
			this.trackDataLayerSession();
			GeneralTrack.getInstance().processSessionStorageEvents();
		});
	}

	trackDataLayerSession = () => {
		if (isInHub() && isAuth() && this.canTrack === true) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({ userSessionLoaded: "true" });
			window.dataLayer.push({ event: "UserSessionAndCookiePreferencesLoaded" });
		}
	};
	render() {
		return (
			<Fragment>
				{this.props.hasHeader ? (
					<Tester companyName="WeVideo" pageName={this.props.pageName} />
				) : null}

				<div className={this.props.hasHeader ? "tester-content-offset" : undefined}>
					{this.props.children}
				</div>

				{this.canTrack === true ? <CookieScripts /> : null}
			</Fragment>
		);
	}
}

DefaultLayout.defaultProps = {
	pageName: "",
	hasHeader: true,
};

DefaultLayout.propTypes = {
	pageName: PropTypes.string,
	hasHeader: PropTypes.bool,
};

const mapStateToProps = state => {
	return {
		appWasLoaded: state.app.appLoaded,
		appLoadError: state.app.error,
	};
};

export default withRouter(connect(mapStateToProps, null)(DefaultLayout));
